<template>
  <a-modal v-model="visible" width="60%" title="采购详情" class="gufiiguy" :maskClosable="false">
    <template slot="footer">
      <a-button type="primary" @click="downloadData" style="float: left"> 导出 </a-button>
      <a-button @click="visible = false"> 取消 </a-button>
      <a-button type="primary" @click="submint"> 确定 </a-button>
      <a-button type="danger" @click="reject(3)" v-if="audit"> 驳回 </a-button>
      <a-button key="submit" type="primary" @click="reject(1)" v-if="audit"> 转交 </a-button>
      <a-button type="primary" @click="reject(2)" v-if="audit"> 通过 </a-button>
    </template>
    <div ref="sadsada">
      <a-form-model v-if="details != null" :model="details" :label-col="labelCol" :wrapper-col="wrapperCol">
        <div class="title">
          <span>基本信息</span>
        </div>
        <div class="content">
          <a-row>
            <a-col :span="24">
              <a-form-model-item
                label="审批标题"
                class="model_span_form"
                :label-col="{ span: 3 }"
                :wrapper-col="{ span: 21 }"
              >
                <span>{{ details.title }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item label="审批编号" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <span class="span">{{ details.purchaseCode }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item label="抄 送 人 " :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <span class="span">{{ details.ccName }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-model-item label="申请部门">
                <span class="span">{{ details.deptFullName }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="申请时间">
                <span class="span">{{ details.createTime }}</span>
              </a-form-model-item>
            </a-col>

            <a-col :span="8">
              <a-form-model-item label="费用归属部门">
                <span class="span">{{ details.ascriptionDept }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-model-item label="采购类型">
                <span class="span">{{ details.itemTypeName }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="期望交付日期">
                <span class="span">{{ details.expectDate }}</span>
              </a-form-model-item>
            </a-col>

            <a-col :span="24">
              <a-form-model-item label="备注" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <span class="span">{{ details.remark }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item label="报价单" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <uploadFileCodeAdd :data="uploadDataAdd" v-if="isRouterAlive && audit && assetsExportConsumables" />
                <div
                  class="view_path"
                  @click="previewFile(item)"
                  v-for="(item, index) in details.quoteList"
                  :key="index"
                >
                  {{ item.name }}
                </div>
              </a-form-model-item>
            </a-col>
          </a-row>
           <a-row>
            <a-col :span="24">
              <a-form-model-item label="文件" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                 <div class="view_path fileBox" @click="previewFile(item)" v-for="(item, index) in details.purchaseList" :key="index">
                    {{ item.name }}
                  </div>
              </a-form-model-item>
            </a-col>
          </a-row>
        </div>
        <div class="title">
          <span>物品信息</span>
        </div>
        <div class="content" style="padding: 10px 20px 15px 20px" v-if="number == 1">
          <a-row>
            <a-table
              :data-source="details.bizGoodsInfos"
              bordered
              :pagination="false"
              style="margin-top: 15px"
              :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            >
              <a-table-column key="index" title="序号" data-index="index" width="70px">
                <template scope="text, record, index">{{ index + 1 }}</template>
              </a-table-column>
              <a-table-column key="name" ellipsis="true" title="物品名称" data-index="name"></a-table-column>
              <a-table-column key="model" ellipsis="true" title="规格型号" data-index="model"></a-table-column>
              <a-table-column key="amount" ellipsis="true" title="数量" data-index="amount"></a-table-column>
              <a-table-column key="unit" ellipsis="true" title="单位" data-index="unit"></a-table-column>
              <a-table-column key="remark" ellipsis="true" title="备注" data-index="remark"></a-table-column>
              <a-table-column key="usagesName" ellipsis="true" title="使用部门" data-index="usagesName">
              </a-table-column>
              <a-table-column key="averageQuote" title="供应商报价均价" data-index="averageQuote" width="150px">
              </a-table-column>
              <a-table-column key="isInvalid" title="申购状态" data-index="isInvalid">
                <template scope="text,record">
                  <a-tag class="span" :color="record.isInvalid == 1 ? 'red' : 'green'">
                    {{ record.isInvalid == 1 ? '作废' : '正常' }}
                  </a-tag>
                </template>
              </a-table-column>
              <a-table-column key="financeStatus" title="财务状态" data-index="financeStatus" width="100px">
                <template scope="text,record">
                  <!-- <span v-if=" record.financeStatus === null">{{ record.financeStatus}}</span> -->
                  <!-- v-if="record.financeStatus == 0" -->
                  <a-tag :color="colorData[record.financeStatus].color">{{
                  colorData[record.financeStatus].text
                  }}</a-tag>
                </template>
              </a-table-column>
              <a-table-column key="purchaseStatus" ellipsis="true"  title="采购状态"  data-index="purchaseStatus"></a-table-column>
              <a-table-column title="操作" width="160px">
                <template scope="text,record">
                  <a @click="supplier(record)" v-if="audit && assetsExportConsumables && (record.companyName == '嘉兴安联' && record.name != '部门主管、分公司总经理（会签）：确认购买需求' && record.processDefName == '采购申请')">填写供应商</a>
                  <a-divider type="vertical" v-if="audit && assetsExportConsumables" />
                  <a @click="show_details(record)">详情</a>
                </template>
              </a-table-column>
            </a-table>
          </a-row>
        </div>
        <div class="content" style="padding: 10px 20px 15px 20px" v-else>
          <a-row>
            <a-table :data-source="details.bizGoodsInfos" bordered :pagination="false" style="margin-top: 15px">
              <a-table-column key="index" title="序号" data-index="index">
                <template scope="text, record, index">{{ index + 1 }}</template>
              </a-table-column>
              <a-table-column key="name" title="物品名称" data-index="name"></a-table-column>
              <a-table-column key="model" title="规格型号" data-index="model"></a-table-column>
              <a-table-column key="amount" title="数量" data-index="amount"></a-table-column>
              <a-table-column key="unit" title="单位" data-index="unit"></a-table-column>
              <a-table-column key="remark" title="备注" data-index="remark"></a-table-column>
              <a-table-column key="usagesName" title="使用部门" data-index="usagesName"> </a-table-column>
              <a-table-column key="averageQuote" title="供应商报价均价" data-index="averageQuote" width="150px">
              </a-table-column>
              <a-table-column key="isInvalid" title="申购状态" data-index="isInvalid">
                <template scope="text,record">
                  <a-tag class="span" :color="record.isInvalid == 1 ? 'red' : 'green'">
                    {{ record.isInvalid == 1 ? '作废' : '正常' }}
                  </a-tag>
                </template>
              </a-table-column>
              <a-table-column key="financeStatus" title="财务状态" data-index="financeStatus" width="100px">
                <template scope="text,record">
                  <!-- <span >{{record.financeStatus}}</span>
                  <span>{{colorData[record.financeStatus].text}}</span> -->
                  <a-tag :color="colorData[record.financeStatus].color">{{
                    colorData[record.financeStatus].text
                  }}</a-tag>
                </template>
              </a-table-column>
              <a-table-column key="purchaseStatus" title="采购状态" data-index="purchaseStatus"></a-table-column>
              <a-table-column title="操作" width="160px">
                <template scope="text,record">
                  <a @click="supplier(record)" v-if="audit && assetsExportConsumables">填写供应商</a>
                  <a-divider type="vertical" v-if="audit && assetsExportConsumables" />
                  <a @click="show_details(record)">详情</a>
                </template>
              </a-table-column>
            </a-table>
          </a-row>
        </div>
        <div class="title" v-if="!audit && recordNumber==1">
          <span>审批记录</span>
        </div>
        <div class="content" v-if="!audit && recordNumber==1">
          <auditModel ref="auditModel"></auditModel>
        </div>
        
      </a-form-model>
    </div>
    <!-- 撤销提示 -->
    <a-modal
      v-model="details_visit"
      width="60%"
      :title="details ? '供应商报价详情' : '填写供应商'"
      :maskClosable="false"
      @cancel="changedata"
    >
      <template slot="footer" v-if="detailsBoo">
        <a-button @click="details_visit = false"> 返回 </a-button>
      </template>
      <template slot="footer" v-else>
        <a-button type="primary" @click="quote"> 确定 </a-button>
        <a-button @click="changedata"> 取消 </a-button>
      </template>
      <a-form-model :model="rowList" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-row style="margin-bottom: 15px"><span class="form_title">表单信息</span></a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="物品名称">
              <span class="span">{{ rowList.name }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="规格型号">
              <span class="span">{{ rowList.model }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="申购数量">
              <span class="span">{{ rowList.amount }}</span>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="单位">
              <span class="span">{{ rowList.unit }}</span>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <a-row v-if="detailsBoo">
        <a-row style="margin-bottom: 15px"><span class="form_title">供应商报价</span></a-row>
        <a-row>
          <a-table :data-source="supplierList" bordered :pagination="false">
            <a-table-column key="index" title="序号" data-index="index">
              <template scope="text, record, index">{{ index + 1 }}</template>
            </a-table-column>
            <a-table-column key="supplierName" ellipsis="true" title="供应商名称" data-index="supplierName">
            </a-table-column>
            <a-table-column key="quote" ellipsis="true" title="报价（单价）" data-index="quote"></a-table-column>
            <a-table-column key="remark" ellipsis="true" title="备注" data-index="remark"></a-table-column>
          </a-table>
        </a-row>
      </a-row>
      <a-row v-else>
        <a-form-model :model="form" ref="ruleForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-row v-for="(item, index) in form" :key="index">
            <a-row>
              <div class="pay_top">
                <span class="form_title">供应商报价{{ index + 1 }}</span>
              </div>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-model-item
                  label="供应商名称"
                  :prop="index + '.supplierName'"
                  :rules="{
                    required: true,
                    message: '请输入供应商名称',
                    trigger: 'blur',
                  }"
                >
                  <a-input v-model="form[index].supplierName" placeholder="请输入"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item
                  label="报价（单价）"
                  :prop="index + '.quote'"
                  :rules="{
                    required: true,
                    message: '请输入报价（单价）',
                    trigger: 'blur',
                  }"
                >
                  <a-input
                    v-model="form[index].quote"
                    oninput="value=value.replace(/[^\d\.]/g,'')"
                    placeholder="请输入"
                  ></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="备注">
                  <a-input v-model="form[index].remark" placeholder="请输入"></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <div style="margin-left: 30px; margin-bottom: 20px">
                <a-button type="danger" @click="delete_detail(index)"> 删除 </a-button>
                <a-button type="primary" @click="add_detail" v-if="form.length - 1 == index"> 新增供应商报价 </a-button>
              </div>
            </a-row>
          </a-row>
        </a-form-model>
      </a-row>
    </a-modal>
    <a-modal
      v-model="is_revocation"
      :title="result == 3 ? '确认驳回此申请吗?' : '确认通过此申请吗?'"
      on-ok="handleOkReason"
    >
      <template slot="footer">
        <a-button key="back" @click="is_revocation = false"> 取消 </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result == 3">
          驳回
        </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result == 2">
          通过
        </a-button>
      </template>
      <a-textarea placeholder="请输入原因" v-model="comment" />
    </a-modal>
    <transferModal ref="transferModal" @sure="handleSure" />
  </a-modal>
</template>
<script>
import { downLoadPdf  } from '@/utils/index'
import auditModel from './audit.vue'
import {
  getPurchaseByBusiness,
  act_task_audit,
  update_goods,
  purchase_apply_downlodPdf,
  purchase_apply_quote,
  purchase_apply_post,
  purchase_apply_delete,
} from '@/api/activiti'
import debounce from 'lodash/debounce'
import { checkPermission } from '@/utils/permissions'
import transferModal from '@/views/activiti/modules/TransferModal.vue'
import uploadFileCodeAdd from '@/components/module/uploadFileCodeAdd.vue'
import Watermark from '../../../utils/watermark'
import { download_file_java } from '@/utils/request'
import { resolveBlob } from '@/utils/index'
export default {
  name: 'LeaveModal',
  props: {
    typeStyle: {
      type: Number,
      default: false,
    },
    apply: {
      type: Number,
      default: true,
    },
    number: {
      type: Number,
      default: false,
    },
    audit: {
      type: Boolean,
      default: true,
    },
    typeIndex: {
      type: Number,
      default: false,
    },
    rowId: {
      type: Number,
      default: false,
    },
  },
  components: {
    transferModal,
    uploadFileCodeAdd,
    auditModel,
  },

  data() {
    return {
      recordNumber: 0,
      colorData: [
        {
          color: 'blue',
          text: '未关联',
        },
        {
          color: 'yellow',
          text: '关联付款',
        },
        {
          color: 'yellow',
          text: '关联报销',
        },
        {
          color: 'green',
          text: '已付款',
        },
        {
          color: 'green',
          text: '已报销',
        },
      ],
      selectedRowKeys: [],
      is_revocation: false,
      result: '',
      comment: '', //驳回原因
      testUrl: '',
      visible: false,
      record: '',
      details: null,
      labelCol: {
        span: 9,
      },
      wrapperCol: {
        span: 15,
      },
      isRouterAlive: true,
      details_visit: false,
      uploadDataAdd: {
        type: 'quote-list',
        parent: '',
      },
      rowList: {},
      supplierList: [],
      detailsBoo: false,
      form: [
        {
          goodsId: '',
          supplierName: '',
          quote: '',
          remark: '',
          goodsData: [],
        },
      ],
      assetsExportConsumables: checkPermission('purchase:quote:save'),
      goodsData: [],
      goodsId: [],
    }
  },
  beforeCreate() {},
  created() {},
  mounted() {
    console.log(this.assetsExportConsumables)
  },
  methods: {
    	//导出
		downloadData() {
			downLoadPdf('/act/purchase_apply/downlodPdf?businessKey=' + this.record.businessKey,)
    },
  //文件预览
     async previewFile(file) {
                let path = '/' + file.url.split('/')[0] + '/'
                let fileName = file.url.substring(file.url.indexOf('/') + 1)
                var res = await download_file_java(file.types, path, fileName)
                var file_s_n = file.name.split('.')
                let type = file_s_n[file_s_n.length - 1]
                resolveBlob(res, this.get_file_type[type]) //新窗口打开，借用浏览器去打印
                },
    //提交事件
    submint() {
      this.$emit('submitGoodList', this.goodList)
      console.log(this.goodList, 'this.goodList==============')
      if (this.number == 1) {
        if (this.goodsData.length) {
          this.$emit('getData', {
            recordId: this.record.businessKey,
            associateId: this.details.id,
            goodId: this.goodsId,
            goodsData: this.goodsData,
            apply: this.apply,
          })
          console.log('666666666666666666666')
        }
      }
      this.number = 0
      this.$emit('changeNumber', this.number)
      console.log(this.number, 'this.number=====================')
      this.selectedRowKeys = ''
      this.visible = false
    },
    onSelectChange(selectedRowKeys, val) {
      if (val.length == 0) {
        this.selectedRowKeys = []
        this.val = []
      } else {
        console.log(selectedRowKeys, val, this.typeIndex, 'selectedRowKeys, val, typeIndex')
        for (var i = val.length - 1; i >= 0; i--) {
          if (val[i].financeStatus == 1 && this.typeIndex == 0) {
            this.$message.warning('此物品已关联付款不可再关联报销！')
            selectedRowKeys.splice(val.length - 1, 1)
            val.splice(val.length - 1, 1)
          } else if (val[i].financeStatus == 3 && this.typeIndex == 0) {
            this.$message.warning('此物品已付款不可再关联报销！')
            selectedRowKeys.splice(val.length - 1, 1)
            val.splice(val.length - 1, 1)
          } else if (val[i].financeStatus == 4 && this.typeIndex == 1) {
            this.$message.warning('此物品已报销不可再关联付款！')
            selectedRowKeys.splice(val.length - 1, 1)
            val.splice(val.length - 1, 1)
          } else if (val[i].financeStatus == 2 && this.typeIndex == 1) {
            this.$message.warning('此物品已关联报销不可再关联付款！')
            selectedRowKeys.splice(val.length - 1, 1)
            val.splice(val.length - 1, 1)
          }
          console.log(selectedRowKeys, val, 'selectedRowKeys, val')
          this.selectedRowKeys = selectedRowKeys
          this.goodsData = val
          this.goodsId = []
          this.goodsData.forEach((item) => {
            this.goodsId.push(item.id)
          })
          console.log(this.goodsId,this.goodsData, 'goodsIdgoodsIdgoodsIdgoodsIdgoodsId')
        }
      }
    },
    changedata() {
      this.details_visit = false
      this.show(this.record)
    },
    delete_detail(index) {
      console.log(index, '_this.supplierList[index].id================')

      var _this = this
      this.$confirm({
        title: '确认删除此供应商报价吗?',
        onOk() {
          if (_this.supplierList[index].id) {
            purchase_apply_delete({
              id: _this.supplierList[index].id,
              procInstId: _this.record.procInstId,
            }).then((res) => {
              if (res.code == 200) {
                _this.$message.success('删除成功！')
                _this.form.splice(index, 1)
              } else {
                _this.$message.error(res.msg)
                return
              }
            })
          } else {
            _this.form.splice(index, 1)
          }
        },
        onCancel() {
          _this.$message.error('你点击了取消！')
        },
        class: 'test',
      })
    },
    add_detail() {
      this.form.push({
        goodsId: '',
        goodsData: [],
        supplierName: '',
        quote: '',
        remark: '',
      })
    },
    supplier(row) {
      purchase_apply_quote(row.id).then((res) => {
        this.supplierList = res.data.list
        if (this.supplierList.length) {
          this.form = this.supplierList
        } else {
          this.form = [
            {
              goodsId: '',
              supplierName: '',
              quote: '',
              remark: '',
            },
          ]
        }
        this.rowList = row
        this.details_visit = true
        this.detailsBoo = false
      })
    },
    quote() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.form.forEach((item) => {
            item.goodsId = this.rowList.id
          })
          purchase_apply_post({
            map: this.form,
            procInstId: this.record.procInstId,
          }).then((res) => {
            if (res.code == 200) {
              this.details_visit = false
              this.$message.success('保存成功')
              this.show(this.record)
            } else {
              this.$message.error(res.msg)
              return
            }
          })
        }
      })
    }, //预览文件
    async previewFile(file) {
      let path = '/' + file.url.split('/')[0] + '/'
      let fileName = file.url.substring(file.url.indexOf('/') + 1)
      var res = await download_file_java(file.types, path, fileName)
      var file_s_n = file.name.split('.')
      let type = file_s_n[file_s_n.length - 1]
      resolveBlob(res, this.get_file_type[type]) //新窗口打开，借用浏览器去打印
    },
    //预览文件
    // previewFile(file) {
    //   window.open(file.preUrl)
    // },
    show_details(row) {
      purchase_apply_quote(row.id).then((res) => {
        this.supplierList = res.data.list
      })
      this.rowList = row
      this.details_visit = true
      this.detailsBoo = true
    },
    handleSure() {
      this.visible = false
      this.$emit('ok')
    },
    download() {
      purchase_apply_downlodPdf({
        businessKey: this.record.businessKey,
      }).then((res) => {
        window.open('https://coa.anliantest.com/oaProxyApi/proxyPython/file/download?path=' + res.data)
      })
    },
    //获取详情
    show(record) {
      this.recordNumber = record.recordNumber
      this.record = record
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
        getPurchaseByBusiness(record.businessKey).then((res) => {
          if (res.code === 200) {
            console.log(this.typeStyle, 'this.typeStylethis.typeStyle')
            if (this.typeStyle == 1) {
              for (var i = res.data.bizGoodsInfos.length - 1; i >= 0; i--) {
                if (res.data.bizGoodsInfos[i].applyIds.indexOf(this.rowId.id) == -1) {
                  res.data.bizGoodsInfos.splice(i, 1)
                }
              }
              for (var i = res.data.bizGoodsInfos.length - 1; i >= 0; i--) {
                if (
                  res.data.bizGoodsInfos[i].financeStatus == '1' ||
                  res.data.bizGoodsInfos[i].financeStatus == '3' ||
                  res.data.bizGoodsInfos[i].financeStatus == '0'
                ) {
                  res.data.bizGoodsInfos.splice(i, 1)
                }
              }
              console.log(res.data.bizGoodsInfos, '666666666666666666666666666666666666')
            } else if (this.typeStyle == 2) {
              for (var i = res.data.bizGoodsInfos.length - 1; i >= 0; i--) {
                if (res.data.bizGoodsInfos[i].applyIds.indexOf(this.rowId.id) == -1) {
                  res.data.bizGoodsInfos.splice(i, 1)
                }
              }
              console.log('22222222222222222222222222')
              console.log(res.data.bizGoodsInfos.length, 'res.data.bizGoodsInfos.length')
              for (var i = res.data.bizGoodsInfos.length - 1; i >= 0; i--) {
                if (
                  res.data.bizGoodsInfos[i].financeStatus == '0' ||
                  res.data.bizGoodsInfos[i].financeStatus == '2' ||
                  res.data.bizGoodsInfos[i].financeStatus == '4'
                ) {
                  res.data.bizGoodsInfos.splice(i, 1)
                }
              }
              console.log(res.data.bizGoodsInfos, '666666666666666666666666666666666666')
            }
            this.details = res.data
            this.uploadDataAdd.parent = res.data.id
            this.visible = true
            this.$nextTick(() => {
              console.log(this.$refs, ' this.$refs==================')
               if(!this.audit && this.recordNumber==1) {
                 this.$refs.auditModel.show(record)
               }
              console.log(this.$refs.sadsada, 'this.$refs.sadsada===============')
              Watermark.set('安联云管家', this.$refs.sadsada)
            })
          }
        })
      })
    },
    //
    reject(result_) {
      if (result_ == 1) {
        this.$refs.transferModal.show({
          record: this.record,
        })
      } else {
        this.is_revocation = true
        this.comment = ''
        this.result = result_
      }
    },
    handleOkReason: debounce(
      function () {
        if (this.result == 3) {
          if (this.comment == '') {
            this.$message.error('请输入驳回意见！')
          } else {
            this.save_audit(this.result)
          }
        } else {
          var lis = this.details.bizGoodsInfos
          var is = true
          lis.forEach((element) => {
            if (element.averageQuote == null || element.averageQuote < 0 || element.averageQuote === '') {
              is = false
              console.log(element, 'element=========================')
            }
          })
          if (this.assetsExportConsumables && (this.record.companyName == '嘉兴安联' && this.record.name != '部门主管、分公司总经理（会签）：确认购买需求' && this.record.processDefName == '采购申请')) {
            if (!is) {
              this.$message.error('请填写供应商！')
              this.is_revocation = false
              return
            }
            this.save_audit(this.result)
          } else {
            this.save_audit(this.result)
          }
        }
      },
      1000,
      {
        leading: true,
        trailing: false,
      }
    ),
    save_audit: debounce(
      function (result_) {
        act_task_audit({
          taskId: this.record.id,
          procDefKey: this.record.processDefKey,
          procInstId: this.record.procInstId,
          procName: this.record.processName,
          applyer: this.record.applyer,
          result: result_,
          businessKey: this.record.businessKey,
          comment: this.comment,
        }).then((res) => {
          if (res.code != 200) {
            this.$message.error(res.msg)
            return
          }
          this.$message.success('审批成功')
          this.$emit('ok')
          this.visible = false
          this.is_revocation = false
        })
      },
      1000,
      {
        leading: true,
        trailing: false,
      }
    ),
    updateSumbit: debounce(
      function (lis, result_) {
        update_goods({
          procInstId: this.record.procInstId,
          bizGoodsInfo: lis,
        }).then((res) => {
          if (res.code == 200) {
            act_task_audit({
              taskId: this.record.id,
              procDefKey: this.record.processDefKey,
              procInstId: this.record.procInstId,
              procName: this.record.processName,
              applyer: this.record.applyer,
              result: result_,
              businessKey: this.record.businessKey,
              comment: this.comment,
            }).then((res) => {
              if (res.code != 200) {
                this.$message.error(res.msg)
                return
              }
              this.$message.success('审批成功')
              this.$emit('ok')
              this.visible = false
              this.is_revocation = false
            })
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      1000,
      {
        leading: true,
        trailing: false,
      }
    ),
  },
  watch: {},
}
</script>
<style lang="less" scoped>
/deep/ .ant-input-disabled {
  color: #000;
  background-color: #fff;
}

/deep/ .ant-select-disabled {
  color: #000;
}

/deep/ .ant-select-selection {
  background-color: #fff;
}

.form_title {
  margin-left: 15px;
  margin-bottom: 15px;
  font-size: 17px;
  color: #999;
}
.fileBox {
  color: #2479e2;

}
</style>
